import { createStore, selectUrl } from '@oneappexchange/lwc-wired';
import { IS_DEVELOPMENT } from '../../config';
import { getMenuItems } from '../utilities/headerUtilities';
import { publisherStore, selectPublisher } from './publisher/publisherStore';
import { routerStore } from './routerStore';
const initialState = {
  showSubmenu: true,
  menu: getMenuItems()
};
export const headerStore = createStore(initialState, set => ({
  updateMenu(url) {
    set(function updateMenu(draft) {
      draft.menu = getMenuItems();
      draft.menu.forEach(function activateMenuItemByHref(menu) {
        let subMenuIsActive = false;
        if (menu.nav) {
          menu.nav.forEach(function activateSubMenuItemByHref(subMenu) {
            if (subMenu.href === url) {
              subMenu.active = true;
              subMenu.styleclass = 'sub-nav-item active';
              subMenuIsActive = true;
            } else {
              subMenu.active = false;
              subMenu.styleclass = 'sub-nav-item';
            }
          });
        }
        if (menu.href === url || subMenuIsActive) {
          menu.active = true;
          menu.styleclass = 'nav-item active';
        } else {
          menu.active = false;
          menu.styleclass = 'nav-item';
        }
      });
      const selectedMenu = draft.menu.find(menu => menu.active);
      draft.showSubmenu = (selectedMenu && selectedMenu.nav || []).length > 0;
    });
  }
}), 'HEADER', IS_DEVELOPMENT);
export function updateHeader() {
  const url = selectUrl(routerStore.getState());
  headerStore.updateMenu(url !== '/' ? `/${url}` : url);
}
routerStore.subscribe(updateHeader, selectUrl);
publisherStore.subscribe(updateHeader, selectPublisher);
export function selectShowSubmenu(state) {
  return state.showSubmenu;
}